import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaExternalLinkAlt } from 'react-icons/fa';
import { api } from '../../App';
import { AdminLayout } from './AdminDashboard';
import './Admin.css';

const AdminFundData = () => {
  const [navData, setNavData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // Form state
  const [newDate, setNewDate] = useState('');
  const [newNav, setNewNav] = useState('');

  useEffect(() => {
    fetchNavData();
  }, []);

  const fetchNavData = async () => {
    try {
      const data = await api.get('/api/admin/fund-nav/fcf');
      setNavData(data.navData || []);
    } catch (error) {
      console.error('Failed to fetch NAV data:', error);
      setError('Napaka pri nalaganju NAV podatkov');
    } finally {
      setLoading(false);
    }
  };

  const handleAddEntry = async (e) => {
    e.preventDefault();
    
    if (!newDate || !newNav) {
      setError('Prosimo, izpolnite oba polja');
      return;
    }

    const navValue = parseFloat(newNav);
    if (isNaN(navValue) || navValue <= 0) {
      setError('Prosimo, vnesite veljavno NAV vrednost');
      return;
    }

    setSaving(true);
    setError('');
    setSuccess('');

    try {
      await api.post('/api/admin/fund-nav/fcf', {
        date: newDate,
        nav: navValue
      });
      
      setSuccess('NAV vnos uspešno dodan');
      setNewDate('');
      setNewNav('');
      fetchNavData();
    } catch (error) {
      setError(error.message || 'Napaka pri dodajanju vnosa');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteEntry = async (id) => {
    if (!window.confirm('Ali ste prepričani, da želite izbrisati ta vnos?')) {
      return;
    }

    try {
      await api.delete(`/api/admin/fund-nav/fcf/${id}`);
      setSuccess('Vnos uspešno izbrisan');
      fetchNavData();
    } catch (error) {
      setError(error.message || 'Napaka pri brisanju vnosa');
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('sl-SI', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <AdminLayout title="First Crypto Fund - NAV Podatki">
      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Nalaganje podatkov...</p>
        </div>
      ) : (
        <>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          {/* Add New Entry Form */}
          <div className="admin-card">
            <h2>Dodaj NAV vnos</h2>
            <form onSubmit={handleAddEntry} className="nav-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="date">Datum</label>
                  <input
                    type="date"
                    id="date"
                    value={newDate}
                    onChange={(e) => setNewDate(e.target.value)}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="nav">NAV vrednost (USD)</label>
                  <input
                    type="number"
                    id="nav"
                    step="0.01"
                    min="0"
                    value={newNav}
                    onChange={(e) => setNewNav(e.target.value)}
                    placeholder="npr. 161.23"
                    className="form-input"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  <FaPlus /> {saving ? 'Dodajanje...' : 'Dodaj vnos'}
                </button>
              </div>
            </form>
          </div>

          {/* NAV Data Table */}
          <div className="admin-card">
            <h2>NAV zgodovina ({navData.length} vnosov)</h2>
            
            {navData.length === 0 ? (
              <p className="empty-message">Še ni NAV vnosov. Dodajte prvi vnos zgoraj.</p>
            ) : (
              <div className="table-container">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Datum</th>
                      <th>NAV (USD)</th>
                      <th>Akcije</th>
                    </tr>
                  </thead>
                  <tbody>
                    {navData.map((entry) => (
                      <tr key={entry.id}>
                        <td>{formatDate(entry.date)}</td>
                        <td className="nav-value">${entry.nav.toFixed(2)}</td>
                        <td>
                          <button 
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteEntry(entry.id)}
                            title="Izbriši vnos"
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Preview Link */}
          <div className="admin-card">
            <h2>Predogled</h2>
            <p>
              <Link to="/first-crypto-fund" className="btn btn-outline" target="_blank">
                <FaExternalLinkAlt style={{ marginRight: '8px' }} />
                Ogled First Crypto Fund strani
              </Link>
            </p>
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default AdminFundData;

